import L1 from './l1.webp';
import L3 from './l3.webp';
import LitUp from './litup.webp';

export default {
    L1,
    L3,
    LitUp
}